var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"item",attrs:{"to":{ name: 'Round', params: { id: _vm.item.id } }}},[_c(_vm.mediaComponent,{tag:"component",attrs:{"item":_vm.item}}),_c('ViewCounter',{staticClass:"views",attrs:{"post":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }